
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video/[id]",
      function () {
        return require("private-next-pages/video/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video/[id]"])
      });
    }
  